import { createContext, useContext } from 'react';

import type { ShortcutRegistry } from './shortcut-registry';

export interface ShortcutManagerContextValue {
  readonly registry: ShortcutRegistry;
}

export const ShortcutManagerContext = createContext<ShortcutManagerContextValue | null>(null);

export function useShortcutManagerContext(): ShortcutManagerContextValue {
  const ctx = useContext(ShortcutManagerContext);
  if (!ctx) {
    throw new Error(
      '[ShortcutManager] useShortcutManagerContext must be used within ShortcutManagerProvider.',
    );
  }
  return ctx;
}
